import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SearchCustomerInternalRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/SearchCustomerInternal.pb'
import { SearchCustomerInternalResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/SearchCustomerInternal.pb'

export const searchCustomerInternal = (request: SearchCustomerInternalRequest, options?: CashRequestOptions) =>
  post<SearchCustomerInternalRequest, SearchCustomerInternalResponse>('/2.0/cash/search-customer-internal', request, {
    ...options,
    rejectOnError: true,
  })
